import * as Sentry from "@sentry/react";

export class WsClient {
  constructor(eventEmitter, url) {
    const socket = new WebSocket(url);

    socket.onopen = () => {
      eventEmitter.emit("connect");
    };

    socket.onclose = () => {
      eventEmitter.emit("disconnect");
      Sentry.withScope(scope => {
        scope.setLevel("warning");
        Sentry.captureMessage("ws disconnect");
      });
    };

    socket.onmessage = message => {
      const data = JSON.parse(message.data);
      eventEmitter.emit(data.event, data);
      eventEmitter.emit("*", data);
    };
  }
}
